/**
 * Shared timezone options for scheduling UI.
 *
 * This list was duplicated verbatim in ScheduleMeetingDialog.tsx and
 * RescheduleMeetingDialog.tsx with HARDCODED abbreviations ("New York (EST)"),
 * which are wrong for roughly half the year — New York is EDT from March to
 * November. Derive the abbreviation at render time instead so it always matches
 * the current offset.
 *
 * The `value` must remain a real IANA zone id: those values are persisted and
 * fed to fromZonedTime()/formatInTimeZone(). Never store abbreviations.
 */
import { formatInTimeZone } from "date-fns-tz";

export interface TimezoneOption {
  value: string;
  /** City/region name without any abbreviation. */
  city: string;
}

export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  { value: "America/Jamaica", city: "Jamaica" },
  { value: "America/New_York", city: "New York" },
  { value: "America/Chicago", city: "Chicago" },
  { value: "America/Denver", city: "Denver" },
  { value: "America/Los_Angeles", city: "Los Angeles" },
  { value: "Europe/London", city: "London" },
  { value: "Europe/Paris", city: "Paris" },
];

/**
 * Builds a display label with the abbreviation that is correct *right now*
 * (e.g. "New York (EDT)" in summer, "New York (EST)" in winter).
 */
export function timezoneLabel(option: TimezoneOption, at: Date = new Date()): string {
  try {
    const abbreviation = formatInTimeZone(at, option.value, "zzz");
    return `${option.city} (${abbreviation})`;
  } catch {
    return option.city;
  }
}
